// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledUserProfile = styled('div')(
  () => css`
    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #eeeef2;
      border: 1px solid #e2e2ea;
    }
  `
);
